import { Link } from "react-router-dom";
import "./navbar.css";
import CompanyLogo from "../../Assets/Images/company_logo.png";
import { Menubar } from "primereact/menubar";


const NavbarCustomBroker = () => {

  const start = (
    <Link to="/" >
      <img src={CompanyLogo} alt="Logo" className="navbar-logo" />
    </Link>
  );
  return (
    <nav className="navbar-container">
      <div className="desktop-navbar">
        <Menubar
          start={start}
        />
      </div>
       <div className="mobile-header-bar">
          {start}
        </div>     
    </nav>
  );
};

export default NavbarCustomBroker;
